function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B430B8",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB5246",
  offset: "55.730672%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD253",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xl/Portal-Asociado-Menu",
  transform: "translate(-180.000000, -883.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "component/Xs/Menu/Portal/Nl+sociales-Copy-4",
  transform: "translate(47.000000, 883.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-icon/60X60/Instagram-Naranja",
  transform: "translate(133.333333, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3-Copy",
  fill: "url(#linearGradient-1)",
  cx: 25,
  cy: 25,
  r: 25
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4117699,16.8451107 C28.3922941,16.7969869 28.0851717,16.7882371 25.5034239,16.7882371 C22.9216761,16.7882371 22.61562,16.7980807 21.5961442,16.8451107 C18.9728069,16.9687014 17.7507156,18.241795 17.6312791,20.9115729 C17.5854241,21.9571722 17.5747601,22.2699769 17.5747601,24.9189741 C17.5747601,27.5679713 17.5854241,27.880776 17.6312791,28.927469 C17.751782,31.5895908 18.9674749,32.8714342 21.5961442,32.9939312 C22.6145536,33.0409613 22.9206097,33.0518985 25.5034239,33.0518985 C28.0862381,33.0518985 28.3922941,33.042055 29.4117699,32.9939312 C32.0351072,32.8725279 33.2508001,31.5939657 33.376635,28.927469 C33.4224901,27.8818698 33.4320877,27.5668775 33.4320877,24.9189741 C33.4320877,22.2710707 33.4224901,21.9571722 33.376635,20.9115729 C33.2550657,18.2428888 32.031908,16.9676077 29.4117699,16.8451107 Z M30.6669195,20.8098567 C30.0261365,20.8098567 29.5066793,20.2770887 29.5066793,19.6198861 C29.5066793,18.9626834 30.0261365,18.4299154 30.6669195,18.4299154 C31.3077025,18.4299154 31.8271597,18.9626834 31.8271597,19.6198861 C31.8300051,19.9373766 31.7090231,20.2428677 31.4911267,20.4684016 C31.2732303,20.6939355 30.9764909,20.8207939 30.6669195,20.8207939 L30.6669195,20.8098567 Z M35.1169954,29.0084045 C34.9581022,32.6176905 33.0001968,34.6126413 29.4928161,34.7788872 C28.4605435,34.827011 28.1310268,34.8379482 25.5044903,34.8379482 C22.8779538,34.8379482 22.5495034,34.827011 21.5172308,34.7788872 C17.9981198,34.6126413 16.0530112,32.6122218 15.8909188,29.0084045 C15.8439973,27.9507743 15.8333333,27.6128139 15.8333333,24.9189741 C15.8333333,22.2251343 15.8439973,21.8882676 15.8909188,20.8295437 C16.0530112,17.2202577 18.0034518,15.2253069 21.5172308,15.0612485 C22.5495034,15.012031 22.8779538,15 25.5044903,15 C28.1310268,15 28.4616099,15.0109372 29.4928161,15.0612485 C33.0119271,15.2274944 34.960235,17.2322887 35.1169954,20.8295437 C35.1639168,21.8882676 35.1745808,22.2251343 35.1745808,24.9189741 C35.1745808,27.6128139 35.1639168,27.951868 35.1169954,29.0084045 Z",
  id: "iconmonstr-instagram-14",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.8039544,30.1870851 C23.7945338,30.1888527 21.9820943,28.948518 21.2123251,27.0448228 C20.442556,25.1411276 20.8671729,22.9492756 22.2880484,21.4919912 C23.7089238,20.0347067 25.8460142,19.5992093 27.7021472,20.3887032 C29.5582802,21.1781972 30.7676261,23.0370793 30.7659028,25.09799 C30.7629622,27.9073692 28.5431436,30.1840692 25.8039544,30.1870851 Z M29.0276734,25.09799 C29.0276734,26.9240227 27.5843652,28.4043147 25.8039544,28.4043147 C24.0235436,28.4043147 22.5802354,26.9240227 22.5802354,25.09799 C22.5802354,23.2719573 24.0235436,21.7916653 25.8039544,21.7916653 C27.5843652,21.7916653 29.0276734,23.2719573 29.0276734,25.09799 L29.0276734,25.09799 Z",
  id: "iconmonstr-instagram-14-path",
  fill: "#FFFFFF"
})))));

function SvgLogoInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "50px",
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5FAE04A6-325C-4EFD-A908-5B50A62566B5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInstagram);
export default __webpack_public_path__ + "static/media/logo-instagram.3635a969.svg";
export { ForwardRef as ReactComponent };